var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootballField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.467 85.333H8.533A8.534 8.534 0 0 0 0 93.867V418.133a8.533 8.533 0 0 0 8.533 8.533h494.933a8.533 8.533 0 0 0 8.533-8.533V93.867a8.533 8.533 0 0 0-8.532-8.534zM264.533 196.948c28.899 4.162 51.2 29.019 51.2 59.052s-22.301 54.89-51.2 59.052V196.948zM17.067 184.887h68.267v142.225H17.067V184.887zm230.4 130.165c-28.899-4.162-51.2-29.019-51.2-59.052s22.301-54.89 51.2-59.052v118.104zm0-135.348C209.127 183.966 179.2 216.542 179.2 256s29.927 72.034 68.267 76.296V409.6h-230.4v-65.421h76.8a8.533 8.533 0 0 0 8.533-8.533V176.354a8.533 8.533 0 0 0-8.533-8.533h-76.8V102.4h230.4v77.304zm247.466 147.409h-68.267V184.887h68.267v142.226zm0-159.292h-76.8a8.533 8.533 0 0 0-8.533 8.533v159.292a8.533 8.533 0 0 0 8.533 8.533h76.8V409.6h-230.4v-77.304c38.34-4.263 68.267-36.838 68.267-76.296s-29.927-72.034-68.267-76.296V102.4h230.4v65.421z",
    fill: "#d8d8d8",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballField);
export default __webpack_public_path__ + "static/media/football-field.42dafea1e30de0e70a0d5d9e311e7920.svg";
export { ForwardRef as ReactComponent };